import React, { useEffect } from 'react';
import { logCaseVisit } from '../../services/api';

const MGZ = () => {
  useEffect(() => {
    logCaseVisit('MONITORING_GOV_PROCUREMENT').catch((error) => {
      console.error(
          'Не удалось залогировать посещение кейса MONITORING_GOV_PROCUREMENT',
          error,
      );
    });
  }, []);

  return (
      <iframe
          width="100%"
          height="95.3%"
          title="Мониторинг государственных закупок"
          src="https://app.powerbi.com/view?r=eyJrIjoiNDFjOWZkMzEtOGY4MC00YjQ2LTkxZjYtYWM1MTgwYjdhODYwIiwidCI6ImZkYTc1ZGJiLTc5MjUtNGM5Ny1hM2NhLTNiZDJmZDU0OWU5MCIsImMiOjl9"
          frameBorder="0"
          allowFullScreen={true}
      />
  );
};

export default MGZ;